import { Headers } from '@angular/http';
import { EntityManager, DataService, config } from 'breeze-client';
import * as breeze from 'breeze-client';

export class Constants {
    public static getJsonHeaders(accessToken: string): Headers {
        let jsonHeaders = new Headers();
        jsonHeaders.append('Accept', 'application/json');
        jsonHeaders.append('Content-Type', 'application/json');
        jsonHeaders.append('Authorization', 'Bearer ' + accessToken);
        return jsonHeaders;
    }

    public static getEntityManager(accessToken: string, url: string) {
        breeze.config.initializeAdapterInstance('uriBuilder', 'json');
        let manager = new EntityManager({
            dataService: new DataService({
                serviceName: url,
                uriBuilderName: 'json',
            }),
        });
        manager.entityChanged;
        Constants.setupBreezeHeaders(accessToken);
        manager.fetchMetadata()
            .catch((error: any) => {
                console.error(`Failed to fetch metadata from ${url}:`, error);
            });
        return manager;
    }

    private static setupBreezeHeaders(accessToken: string) {
        let adapter: any = config.getAdapterInstance('ajax');
        adapter.defaultSettings = {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Constants.ts